import React from "react";
import FeedSkeletonCard from "./feedSkeletonCard";

export default function FeedSkeletonList({ count = 4 }) {
  return (
    <>
      {Array.from({ length: count }).map((_, i) => (
        <FeedSkeletonCard key={i} />
      ))}
    </>
  );
}
